import type { EntityPath2TypeSignature } from "../../_metadata/EntityPath2TypeSignature";
import type { MetaTypeKey } from "../../contracts/utils/metadata/MetaTypeKey";
import { MetaTypeKey as MetaTypeKeyImpl } from "./MetaTypeKey";

type BacklogMetadataPropertySignature = EntityPath2TypeSignature;

export const getMetaTypeKey: BacklogMetadataPropertySignature = <T>(
	path: string,
): MetaTypeKey<T> => {
	return new MetaTypeKeyImpl(path);
};
